const event = (name, params = {}) => {
  const payload = { event: name, ...params }
  if (process.env.PREACT_APP_FAUX_GA === 'true') {
    console.log(`*** TRACKING EVENT: ${JSON.stringify(payload)}`)
  } else {
    window.dataLayer.push(payload)
  }
}

const pageView = pagePath => {
  const payload = { event: 'pageView', pagePath }
  /*Only fire the tracking event on virtual page loads, not initial site load*/
  if(sessionStorage.getItem('initialLoad') == 1){
    //do the thing
    console.log("initialLoad item detected, GA events enabled");
    if (process.env.PREACT_APP_FAUX_GA === 'true') {
      console.log(`*** TRACKING PAGEVIEW EVENT: ${JSON.stringify(payload)}`)
    } else {
      window.dataLayer.push(payload)
    }
  } else{
    //don't do the thing, set initialLoad
    sessionStorage.setItem('initialLoad', 1);
    console.log("no initialLoad item detected, set to 1.  PageView events disabled.");
  }
  
}

export default { event, pageView }



// WEBPACK FOOTER //
// ./src/utils/tracking.js